import { z } from "@/zod";
import {
  apartmentNumber,
  city,
  postalCode,
  streetName,
  streetNumber,
} from "@/schemas/commonFields";
import { phoneNumber } from "./commonFields";

export const invoiceAddress = z.object({
  city_invoice: city,
  street_name_invoice: streetName,
  street_number_invoice: streetNumber,
  apartment_number_invoice: apartmentNumber.nullish(),
  postal_code_invoice: postalCode,
  contact_person_invoice: z.string().nullish(),
  email_invoice: z.string().nullish(),
  phone_number_invoice: z.union([z.literal(""), phoneNumber]).nullish(),
});
